import { defineComponent as _defineComponent } from 'vue'
import { ref, inject, watch } from 'vue';
import { useRoute } from 'vue-router/composables';
import {
  BaseText,
  ButtonContainer,
  ButtonSecondary,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { ModalCreateWallet } from './components/ModalCreateWallet';
import { ProductCard } from './components/ProductCard';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  IDataConfirmEdit,
  IEditPortfolioResponse,
  IProductRemove,
  IProductsRemoveParam
} from '@/modules/wallet-builder/src/services/types/models/IBffInvestments';
import { IProductGetLastState } from '@/modules/catalog/services/products-acquisition';
import { useRouter } from 'vue-router/composables';

interface Props {
  products: IProductGetLastState[];
  isDeleteActive: boolean;
  portfolioId?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectedProductList',
  props: {
    products: null,
    isDeleteActive: { type: Boolean },
    portfolioId: null
  },
  emits: ['show-wallet-selection', 'disable-delete-mode'],
  setup(__props: any, { emit }) {

const props = __props as {
  products: IProductGetLastState[];
  isDeleteActive: boolean;
  portfolioId?: string;
};



const route = useRoute();

const removeProductFromWallet = inject(
  'removeProductFromWallet',
  async (params: IProductsRemoveParam) => ({ params })
);

const confirmEditPortfolio = inject(
  'confirmEditPortfolio',
  async (_: IDataConfirmEdit) => ({ name: '' } as IEditPortfolioResponse)
);

watch(
  () => props.products,
  (newValue, _) => {
    if (newValue.length === 0) {
      emit('show-wallet-selection');
    }
  }
);

watch(
  () => props.isDeleteActive,
  (newValue, _) => {
    if (!newValue) {
      productSelected.value = [];
    }
  }
);
const router = useRouter();

const productSelected = ref<string[]>([]);

const showWalletModal = ref(false);

const isLoading = ref(false);

const isLoadingRemove = ref(false);

function handleAddEvent() {
  showWalletModal.value = !showWalletModal.value;
}

async function handleEditEvent() {
  isLoading.value = true;

  const result = await confirmEditPortfolio({
    portfolioId: route.params.portfolioId!
  });

  isLoading.value = false;

  router.replace({
    name: 'wealthWalletEdited',
    params: { id: route.params.portfolioId ?? '' },
    query: { portfolioname: result?.name || '-' }
  });
}

function handleInstrumentSelected({ id }: IProductRemove) {
  if (props.isDeleteActive) {
    if (productSelected.value.includes(id)) {
      productSelected.value = productSelected.value.filter(item => item !== id);
    } else {
      productSelected.value.push(id);
    }
  }
}

async function handleDeleteProduct() {
  try {
    isLoadingRemove.value = true;
    await removeProductFromWallet({ productIds: productSelected.value });
  } finally {
    emit('disable-delete-mode');
    isLoadingRemove.value = false;
  }
}

return { __sfc: true,props, emit, route, removeProductFromWallet, confirmEditPortfolio, router, productSelected, showWalletModal, isLoading, isLoadingRemove, handleAddEvent, handleEditEvent, handleInstrumentSelected, handleDeleteProduct, BaseText, ButtonContainer, ButtonSecondary, ButtonPrimary, ModalCreateWallet, ProductCard, NebraskaColors }
}

})